import { render, staticRenderFns } from "./PaymentDisabledForm.vue?vue&type=template&id=67c5a5f6&scoped=true"
import script from "./PaymentDisabledForm.vue?vue&type=script&lang=ts"
export * from "./PaymentDisabledForm.vue?vue&type=script&lang=ts"
import style0 from "./PaymentDisabledForm.vue?vue&type=style&index=0&id=67c5a5f6&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c5a5f6",
  null
  
)

export default component.exports